<template>
  <div>
    <div class="px-3">
      <FilterWrapper>
        <template slot="filterForm">
          <TaxFilter
            :loading="loading"
            :rLoading="rLoading"
            :submitFilter="refetch"
            :clearFilter="() => clearFilter('taxRef')"
          />
        </template>
      </FilterWrapper>
    </div>
    <TableWrapper
      :loading="loading"
      :errorMsg="errorMsg"
      :refetch="fetchMerchantTaxes"
      :isEmpty="isEmpty"
      :emptyTitle="emptyTitle"
    >
      <div class="w-100 py-3" slot="content">
        <v-server-table
          ref="taxRef"
          class="v-table row-pointer"
          :data="customers"
          :columns="columns"
          :options="options"
          @loaded="onLoaded"
        >
          <template slot="country" slot-scope="{ row }">
            {{ titleCase(row.country) }}
          </template>
          <template slot="tax_type" slot-scope="{ row }">
            {{ titleCase(row.tax_type) }}
          </template>
          <template slot="type" slot-scope="{ row }">
            {{ titleCase(row.type) }}
          </template>
          <template slot="createdAt" slot-scope="{ row }">
            {{ row.createdAt | moment(" MM-DD-YYYY h:mm a") }}
          </template>
        </v-server-table>
      </div>
    </TableWrapper>
  </div>
</template>

<script>
import { componentData } from "../../../../../../public/assets/mixins/componentData";
import TableWrapper from "../../../../../components/utils/TableWrapper/TableWrapper.vue";
import TaxFilter from "../../../../../components/filters/TaxFilter.vue";

const plansHeadings = {
  id: "Tax ID",
  name: "Name",
  country: "Country",
  rate: "Rate",
  tax_type: "Tax Type",
  type: "variant",
  createdAt: "Date Created",
};

export default {
  name: "Taxes",
  mixins: [componentData],
  data() {
    return {
      singleInviteObj: null,
      showSingleInviteModal: false,
      emptyTitle: "No Tax Found",
      showInviteModal: false,
      loading: false,
      errorMsg: "",
      customers: [],
      ...this.tableOptions(plansHeadings, 25),
    };
  },
  components: {
    TableWrapper,
    TaxFilter,
  },
  methods: {
    async fetchMerchantTaxes() {
      this.options.requestFunction = async (data) => {
        const params = {
          ...data,
          ...this.filters,
          id: this.clientid,
          size: 25,
        };
        const response = await this.$store.dispatch(
          "customer/getPaymentMerchantTaxes",
          {
            params,
          }
        );

        const newData = response.data.data;
        const count = response.data.count;
        return { ...response, count, total: count, data: newData };
      };
    },
    refetch(filters) {
      let newFilters = { ...filters };
      if (newFilters.type) newFilters.type = newFilters.type.value;
      this.handleRefetch(newFilters, this.fetchMerchantTaxes, "taxRef");
    },
  },

  props: ["clientid"],
  created() {
    this.fetchMerchantTaxes();
  },
  mounted() {
    this.columns = Object.keys(plansHeadings).map((keyVal) => keyVal);
  },
};
</script>
